<template>
  <div class="shipping-forensics-log">
    <b-table
      striped
      hover
      :items="forensicsLog"
      :fields="fields"
      :current-page="0"
      :per-page="100"
    >
      <template v-slot:cell(change)="row">
        <b-button size="sm" @click.prevent="showOriginal = !showOriginal" v-if="(row.index + 1) === forensicsLog.length" class="mb-3">
          <translate>Original Shipping Data</translate>
        </b-button>
        <ul v-show="(row.index + 1) !== forensicsLog.length || showOriginal">
          <li v-for="(value, key) in row.item.details" :key="key">{{ key }}: <span v-html="isJson(value)"></span></li>
        </ul>
      </template>

      <template v-slot:cell(by)="row">
        {{row.item.applied_by ? row.item.applied_by.name : 'System'}}
      </template>

      <template v-slot:cell(at)="row">
        {{moment.utc(row.item.created_at).tz($tz).format('L LT')}}
      </template>
    </b-table>
  </div>
</template>

<script>
export default {
  name: 'ShippingForensicsLog',
  props: {
    shipping: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      fields: [
        {
          key: 'change',
          label: this.$gettext('Change Made')
        },
        {
          key: 'by',
          label: this.$gettext('By')
        },
        {
          key: 'at',
          label: this.$gettext('At')
        }
      ],
      statusUsers: [],
      forensicsLog: [],
      showOriginal: false
    }
  },
  watch: {
    shipping: {
      handler(val) {
        this.fetchForensicsLog()
      },
      deep: true
    }
  },
  created() {
    this.fetchForensicsLog()
  },
  methods: {
    fetchStatusUsers() {
      const userIds = []
      for (const entry of this.shipping.status_history) {
        if (entry.user_id) {
          userIds.push(entry.user_id)
        }
      }
      if (userIds.length > 0) {
        const params = {
          page: 0,
          limit: 100,
          filter_groups: [
            {
              filters: [['id', 'in', [...new Set(userIds)]]]
            }
          ]
        }
        this.$http.get(this.$appConfig.api.baseUrl + 'users', { params })
          .then(response => {
            this.statusUsers = response.body.data
          })
      }
    },
    fetchForensicsLog() {
      const params = {
        includes: [
          'applied_by'
        ],
        sort: [{
          key: 'created_at',
          direction: 'desc'
        }],
        filter_groups: [{
          filters: [
            ['shipping_id', 'eq', this.shipping.id]
          ]
        }]
      }
      this.$http.get(this.$appConfig.api.baseUrl + 'shippings/history', { params })
        .then(response => {
          this.forensicsLog = response.body.data
        })
    }
  }
}
</script>

<style lang="scss">
.shipping-forensics-log {
  overflow: auto;
}
</style>
